/* tslint:disable */
import {
  Account,
  Worker,
  Users,
  Jobsite,
  CountryCode,
  GeoMetro,
  Skilling,
  Department,
  StateManager
} from '../index';

declare var Object: any;
export interface ContactInterface {
  "UserId"?: number;
  "sfdcId"?: string;
  "AccountId"?: string;
  "Active__c"?: boolean;
  "Advanced_System_User__c"?: boolean;
  "AssistantName"?: string;
  "AssistantPhone"?: string;
  "Bachelors_Degree__c"?: string;
  "Birthdate"?: Date;
  "CKSW_BASE__Languages__c"?: string;
  "CKSW_BASE__Level__c"?: string;
  "Candidate_Id_Ref__c"?: string;
  "Contact_Full_Name__c"?: string;
  "Contact_Name__c"?: string;
  "Contact_Overview__c"?: string;
  "Contact_Time_Zone__c"?: string;
  "Contact_Type__c"?: string;
  "ContractorHourly__c"?: string;
  "Country_Code__c"?: string;
  "CreatedById"?: string;
  "CreatedDate"?: Date;
  "CurrencyIsoCode"?: string;
  "Current_Employer__c"?: string;
  "Department"?: string;
  "Description"?: string;
  "Disable_PMS_Portal_Login__c"?: boolean;
  "Education_Years__c"?: number;
  "Email"?: string;
  "EmailBouncedDate"?: Date;
  "EmailBouncedReason"?: string;
  "Email__c"?: string;
  "Employed__c"?: string;
  "Enable_App_Login__c"?: boolean;
  "Enable_Inventory_Update__c"?: boolean;
  "ExperienceYrs__c"?: number;
  "Fax"?: string;
  "FirstName"?: string;
  "GEO_Code__c"?: string;
  "Gender__c"?: string;
  "Graduation_Date__c"?: Date;
  "HomePhone"?: string;
  "IsDeleted"?: boolean;
  "IsEmailBounced"?: boolean;
  "Jigsaw"?: string;
  "JigsawContactId"?: string;
  "Job_Opportunity__c"?: string;
  "Languages_Known__c"?: string;
  "LastActivityDate"?: Date;
  "LastCURequestDate"?: Date;
  "LastCUUpdateDate"?: Date;
  "LastLogin__c"?: Date;
  "LastModifiedById"?: string;
  "LastModifiedBy__c"?: string;
  "LastModifiedDate"?: Date;
  "LastName"?: string;
  "LastReferencedDate"?: Date;
  "LastViewedDate"?: Date;
  "LeadId__c"?: string;
  "LeadSource"?: string;
  "LinkedIn_Profile_Link__c"?: string;
  "List_of_Locations__c"?: string;
  "LocationList__c"?: string;
  "MSP_Portal_User_Name__c"?: string;
  "MailingAddress"?: string;
  "MailingCity"?: string;
  "MailingCountry"?: string;
  "MailingGeocodeAccuracy"?: string;
  "MailingLatitude"?: number;
  "MailingLongitude"?: number;
  "MailingPostalCode"?: string;
  "MailingState"?: string;
  "MailingStreet"?: string;
  "MasterRecordId"?: string;
  "Masters_Degree__c"?: string;
  "MobilePhone"?: string;
  "MyHomeMetro_Code__c"?: string;
  "Name"?: string;
  "OtherAddress"?: string;
  "OtherCity"?: string;
  "OtherCountry"?: string;
  "OtherGeocodeAccuracy"?: string;
  "OtherLatitude"?: number;
  "OtherLongitude"?: number;
  "OtherPhone"?: string;
  "OtherPostalCode"?: string;
  "OtherState"?: string;
  "OtherStreet"?: string;
  "OwnerId"?: string;
  "PMS_User_Name__c"?: string;
  "Partner_Account__c"?: string;
  "Password__c"?: string;
  "Phone"?: string;
  "PhotoUrl"?: string;
  "Post_Graduation_Date__c"?: Date;
  "Reason_For_switching__c"?: string;
  "RecordTypeId"?: string;
  "Record_Id__c"?: string;
  "ReportsToId"?: string;
  "Resource_Id__c"?: string;
  "Resume__c"?: string;
  "Role__c"?: string;
  "Salutation"?: string;
  "Skilling__c"?: string;
  "Standard_System_User__c"?: boolean;
  "State__c"?: string;
  "Strengths_Weaknesses__c"?: string;
  "Title"?: string;
  "Total_Experience_Months__c"?: number;
  "Total_Work_Exp__c"?: number;
  "User_Id__c"?: string;
  "User_Type__c"?: string;
  "Username__c"?: string;
  "WM_Contact_Id__c"?: string;
  "WM_User_ID__c"?: string;
  "sendLoginInfo__c"?: boolean;
  "Action__c"?: string;
  "Active_Search__c"?: boolean;
  "Asst_Email__c"?: string;
  "Best_Fit__c"?: string;
  "Business_Telephone_Number__c"?: string;
  "Business_Unit__c"?: string;
  "Candidate_Source__c"?: string;
  "Certifications__c"?: string;
  "Contact_Method__c"?: string;
  "Contact_Tags__c"?: string;
  "Credentials_Private_Key__c"?: string;
  "Current_Hourly__c"?: number;
  "Current_Salary__c"?: number;
  "Date_Available__c"?: Date;
  "Desired_Hourly__c"?: number;
  "Desired_Salary__c"?: number;
  "DischargeStatus__c"?: string;
  "Doc_Id__c"?: string;
  "EEO_Disabled_Received__c"?: string;
  "EEO_Disabled__c"?: string;
  "EEO_Gender_Received__c"?: string;
  "EEO_Gender__c"?: string;
  "EEO_Populate__c"?: boolean;
  "EEO_Race_Received__c"?: string;
  "EEO_Race__c"?: string;
  "EEO_Veteran_Status_Received__c"?: string;
  "EEO_Veteran_Status__c"?: string;
  "EduDegreeDate1__c"?: Date;
  "EduDegreeDate2__c"?: Date;
  "EduDegreeMajor1__c"?: string;
  "EduDegreeMajor2__c"?: string;
  "EduDegreeMinor1__c"?: string;
  "EduDegreeMinor2__c"?: string;
  "EduDegreeName1__c"?: string;
  "EduDegreeName2__c"?: string;
  "EduDegreeType1__c"?: string;
  "EduDegreeType2__c"?: string;
  "EduOtherHonors1__c"?: string;
  "EduOtherHonors2__c"?: string;
  "EduacademicHonors1__c"?: string;
  "EduacademicHonors2__c"?: string;
  "Education_School_1__c"?: string;
  "Education_School_2__c"?: string;
  "Education__c"?: string;
  "Edudocumentation1__c"?: string;
  "Edudocumentation2__c"?: string;
  "EduhonorsProgram1__c"?: string;
  "EduhonorsProgram2__c"?: string;
  "EduschoolTypes1__c"?: string;
  "EduschoolTypes2__c"?: string;
  "Emp_PositionHistory_positiontype1__c"?: string;
  "Emp_PositionHistory_positiontype2__c"?: string;
  "Employer1CategoryCode__c"?: string;
  "Employer1Description__c"?: string;
  "Employer1EndDate__c"?: Date;
  "Employer1StartDate__c"?: Date;
  "Employer1Title__c"?: string;
  "Employer2Description__c"?: string;
  "Employer2EndDate__c"?: Date;
  "Employer2StartDate__c"?: Date;
  "Employer2Title__c"?: string;
  "Employer2_Category_Code__c"?: string;
  "Employer3Description__c"?: string;
  "Employer3EndDate__c"?: Date;
  "Employer3StartDate__c"?: Date;
  "Employer3Title__c"?: string;
  "Employer3_Category_Code__c"?: string;
  "EmployerOrgName_1__c"?: string;
  "EmployerOrgName_2__c"?: string;
  "EmployerOrgName_3__c"?: string;
  "Executive_summary__c"?: string;
  "Experience_Summary__c"?: string;
  "Facebook_Profile__c"?: string;
  "Firstname__c"?: string;
  "Geo_Location_Passed__c"?: boolean;
  "Hard_Rating__c"?: string;
  "Hard_Skills__c"?: string;
  "HasEmailBounced__c"?: boolean;
  "Hide_Photo__c"?: boolean;
  "Home_Telephone_Number__c"?: string;
  "I9_Received__c"?: boolean;
  "Internet_Email_Address__c"?: string;
  "Job_Type__c"?: string;
  "Jobs_Applied_For__c"?: string;
  "LUID__c"?: string;
  "Language_Comments_1__c"?: string;
  "Language_Comments_2__c"?: string;
  "Language_Read_1__c"?: string;
  "Language_Read_2__c"?: string;
  "Language_Speak_1__c"?: string;
  "Language_Speak_2__c"?: string;
  "Language_Write_1__c"?: string;
  "Language_Write_2__c"?: string;
  "Languages__c"?: string;
  "Lastname__c"?: string;
  "Latitude__c"?: number;
  "Legacy_ContactID__c"?: string;
  "Legacy_DocumentID__c"?: string;
  "Level__c"?: string;
  "License_or_Certification_Credential_Type__c"?: string;
  "License_or_Certification_Description_1__c"?: string;
  "License_or_Certification_Description_2__c"?: string;
  "License_or_Certification_Name_1__c"?: string;
  "License_or_Certification_Name_2__c"?: string;
  "LinkedIn_Profile__c"?: string;
  "Login_Password__c"?: string;
  "Longitude__c"?: number;
  "MailingCountryText__c"?: string;
  "MailingStateText__c"?: string;
  "Match__c"?: number;
  "Memo__c"?: string;
  "Middlename__c"?: string;
  "Military_History_Type__c"?: string;
  "Mobile_Telephone_Number__c"?: string;
  "Notice__c"?: string;
  "Opt_In_to_Job_Alerts__c"?: boolean;
  "People_Status__c"?: string;
  "Picture_Id__c"?: string;
  "Picture__c"?: string;
  "Preferred_Name__c"?: string;
  "Qualification_Summary__c"?: string;
  "Reference_1__c"?: string;
  "Reference_2__c"?: string;
  "Referral_Lookup__c"?: string;
  "ReferrerEmailMessage__c"?: string;
  "ReferrerEmailSubject__c"?: string;
  "Relocated__c"?: boolean;
  "Relocation_Date__c"?: Date;
  "Resume_Last_Updated__c"?: Date;
  "SSN1__c"?: string;
  "SSN2__c"?: string;
  "SSN3__c"?: string;
  "Search_Social_Profiles__c"?: string;
  "Second_Best_Fit__c"?: string;
  "Security_Credential_1__c"?: string;
  "Security_Credential_Description_1__c"?: string;
  "Security_Credential_Type_1__c"?: string;
  "SessionKey__c"?: string;
  "Shift__c"?: string;
  "Skill_Codes__c"?: string;
  "Social_Security__c"?: string;
  "Soft_Rating__c"?: string;
  "Soft_Skills__c"?: number;
  "Source_Notes__c"?: string;
  "Source__c"?: string;
  "Taxonomy_Last_12_Months__c"?: string;
  "Taxonomy_Qualifications__c"?: string;
  "Taxonomy_Skills__c"?: string;
  "Taxonomy_Work_History_12_24__c"?: string;
  "Taxonomy_Work_History_24_36__c"?: string;
  "Taxonomy_Work_History_36_48__c"?: string;
  "Text_Resume__c"?: string;
  "Total_Months_Employed__c"?: number;
  "Travel_Desired__c"?: number;
  "Twitter_Profile__c"?: string;
  "Verified_Date__c"?: Date;
  "Verified_Key__c"?: string;
  "Verified__c"?: boolean;
  "W4_Received__c"?: boolean;
  "Years_of_Experience__c"?: number;
  "iPaper_Key__c"?: string;
  "Languages_js__c"?: string;
  "Level_js__c"?: string;
  "Initiate_Background_Check__c"?: boolean;
  "zeitzone__MailingLTFactor__c"?: number;
  "zeitzone__MailingLocalTime__c"?: string;
  "zeitzone__MailingTimeZoneId__c"?: string;
  "zeitzone__OtherLTFactor__c"?: number;
  "zeitzone__OtherLocalTime__c"?: string;
  "zeitzone__otherTimeZoneId__c"?: string;
  "Candidate_Salary_Term__c"?: string;
  "Count_of_Primary_Email__c"?: number;
  "Health_MSP_Email__c"?: string;
  "Health_Portal_Access__c"?: string;
  "MSP_Internal_Email_verified__c"?: boolean;
  "Portal_Access_Email__c"?: boolean;
  "Full_Account_Name__c"?: string;
  "Send_RFI_Email__c"?: boolean;
  "isMailingAddressChanged__c"?: boolean;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  account?: Account;
  worker?: Worker[];
  users?: Users;
  jobsite?: Jobsite;
  countryCode?: CountryCode;
  geometro?: GeoMetro;
  skillings?: Skilling[];
  department?: Department;
  stateManager?: StateManager;
}

export class Contact implements ContactInterface {
  "UserId": number;
  "sfdcId": string;
  "AccountId": string;
  "Active__c": boolean;
  "Advanced_System_User__c": boolean;
  "AssistantName": string;
  "AssistantPhone": string;
  "Bachelors_Degree__c": string;
  "Birthdate": Date;
  "CKSW_BASE__Languages__c": string;
  "CKSW_BASE__Level__c": string;
  "Candidate_Id_Ref__c": string;
  "Contact_Full_Name__c": string;
  "Contact_Name__c": string;
  "Contact_Overview__c": string;
  "Contact_Time_Zone__c": string;
  "Contact_Type__c": string;
  "ContractorHourly__c": string;
  "Country_Code__c": string;
  "CreatedById": string;
  "CreatedDate": Date;
  "CurrencyIsoCode": string;
  "Current_Employer__c": string;
  "Department": string;
  "Description": string;
  "Disable_PMS_Portal_Login__c": boolean;
  "Education_Years__c": number;
  "Email": string;
  "EmailBouncedDate": Date;
  "EmailBouncedReason": string;
  "Email__c": string;
  "Employed__c": string;
  "Enable_App_Login__c": boolean;
  "Enable_Inventory_Update__c": boolean;
  "ExperienceYrs__c": number;
  "Fax": string;
  "FirstName": string;
  "GEO_Code__c": string;
  "Gender__c": string;
  "Graduation_Date__c": Date;
  "HomePhone": string;
  "IsDeleted": boolean;
  "IsEmailBounced": boolean;
  "Jigsaw": string;
  "JigsawContactId": string;
  "Job_Opportunity__c": string;
  "Languages_Known__c": string;
  "LastActivityDate": Date;
  "LastCURequestDate": Date;
  "LastCUUpdateDate": Date;
  "LastLogin__c": Date;
  "LastModifiedById": string;
  "LastModifiedBy__c": string;
  "LastModifiedDate": Date;
  "LastName": string;
  "LastReferencedDate": Date;
  "LastViewedDate": Date;
  "LeadId__c": string;
  "LeadSource": string;
  "LinkedIn_Profile_Link__c": string;
  "List_of_Locations__c": string;
  "LocationList__c": string;
  "MSP_Portal_User_Name__c": string;
  "MailingAddress": string;
  "MailingCity": string;
  "MailingCountry": string;
  "MailingGeocodeAccuracy": string;
  "MailingLatitude": number;
  "MailingLongitude": number;
  "MailingPostalCode": string;
  "MailingState": string;
  "MailingStreet": string;
  "MasterRecordId": string;
  "Masters_Degree__c": string;
  "MobilePhone": string;
  "MyHomeMetro_Code__c": string;
  "Name": string;
  "OtherAddress": string;
  "OtherCity": string;
  "OtherCountry": string;
  "OtherGeocodeAccuracy": string;
  "OtherLatitude": number;
  "OtherLongitude": number;
  "OtherPhone": string;
  "OtherPostalCode": string;
  "OtherState": string;
  "OtherStreet": string;
  "OwnerId": string;
  "PMS_User_Name__c": string;
  "Partner_Account__c": string;
  "Password__c": string;
  "Phone": string;
  "PhotoUrl": string;
  "Post_Graduation_Date__c": Date;
  "Reason_For_switching__c": string;
  "RecordTypeId": string;
  "Record_Id__c": string;
  "ReportsToId": string;
  "Resource_Id__c": string;
  "Resume__c": string;
  "Role__c": string;
  "Salutation": string;
  "Skilling__c": string;
  "Standard_System_User__c": boolean;
  "State__c": string;
  "Strengths_Weaknesses__c": string;
  "Title": string;
  "Total_Experience_Months__c": number;
  "Total_Work_Exp__c": number;
  "User_Id__c": string;
  "User_Type__c": string;
  "Username__c": string;
  "WM_Contact_Id__c": string;
  "WM_User_ID__c": string;
  "sendLoginInfo__c": boolean;
  "Action__c": string;
  "Active_Search__c": boolean;
  "Asst_Email__c": string;
  "Best_Fit__c": string;
  "Business_Telephone_Number__c": string;
  "Business_Unit__c": string;
  "Candidate_Source__c": string;
  "Certifications__c": string;
  "Contact_Method__c": string;
  "Contact_Tags__c": string;
  "Credentials_Private_Key__c": string;
  "Current_Hourly__c": number;
  "Current_Salary__c": number;
  "Date_Available__c": Date;
  "Desired_Hourly__c": number;
  "Desired_Salary__c": number;
  "DischargeStatus__c": string;
  "Doc_Id__c": string;
  "EEO_Disabled_Received__c": string;
  "EEO_Disabled__c": string;
  "EEO_Gender_Received__c": string;
  "EEO_Gender__c": string;
  "EEO_Populate__c": boolean;
  "EEO_Race_Received__c": string;
  "EEO_Race__c": string;
  "EEO_Veteran_Status_Received__c": string;
  "EEO_Veteran_Status__c": string;
  "EduDegreeDate1__c": Date;
  "EduDegreeDate2__c": Date;
  "EduDegreeMajor1__c": string;
  "EduDegreeMajor2__c": string;
  "EduDegreeMinor1__c": string;
  "EduDegreeMinor2__c": string;
  "EduDegreeName1__c": string;
  "EduDegreeName2__c": string;
  "EduDegreeType1__c": string;
  "EduDegreeType2__c": string;
  "EduOtherHonors1__c": string;
  "EduOtherHonors2__c": string;
  "EduacademicHonors1__c": string;
  "EduacademicHonors2__c": string;
  "Education_School_1__c": string;
  "Education_School_2__c": string;
  "Education__c": string;
  "Edudocumentation1__c": string;
  "Edudocumentation2__c": string;
  "EduhonorsProgram1__c": string;
  "EduhonorsProgram2__c": string;
  "EduschoolTypes1__c": string;
  "EduschoolTypes2__c": string;
  "Emp_PositionHistory_positiontype1__c": string;
  "Emp_PositionHistory_positiontype2__c": string;
  "Employer1CategoryCode__c": string;
  "Employer1Description__c": string;
  "Employer1EndDate__c": Date;
  "Employer1StartDate__c": Date;
  "Employer1Title__c": string;
  "Employer2Description__c": string;
  "Employer2EndDate__c": Date;
  "Employer2StartDate__c": Date;
  "Employer2Title__c": string;
  "Employer2_Category_Code__c": string;
  "Employer3Description__c": string;
  "Employer3EndDate__c": Date;
  "Employer3StartDate__c": Date;
  "Employer3Title__c": string;
  "Employer3_Category_Code__c": string;
  "EmployerOrgName_1__c": string;
  "EmployerOrgName_2__c": string;
  "EmployerOrgName_3__c": string;
  "Executive_summary__c": string;
  "Experience_Summary__c": string;
  "Facebook_Profile__c": string;
  "Firstname__c": string;
  "Geo_Location_Passed__c": boolean;
  "Hard_Rating__c": string;
  "Hard_Skills__c": string;
  "HasEmailBounced__c": boolean;
  "Hide_Photo__c": boolean;
  "Home_Telephone_Number__c": string;
  "I9_Received__c": boolean;
  "Internet_Email_Address__c": string;
  "Job_Type__c": string;
  "Jobs_Applied_For__c": string;
  "LUID__c": string;
  "Language_Comments_1__c": string;
  "Language_Comments_2__c": string;
  "Language_Read_1__c": string;
  "Language_Read_2__c": string;
  "Language_Speak_1__c": string;
  "Language_Speak_2__c": string;
  "Language_Write_1__c": string;
  "Language_Write_2__c": string;
  "Languages__c": string;
  "Lastname__c": string;
  "Latitude__c": number;
  "Legacy_ContactID__c": string;
  "Legacy_DocumentID__c": string;
  "Level__c": string;
  "License_or_Certification_Credential_Type__c": string;
  "License_or_Certification_Description_1__c": string;
  "License_or_Certification_Description_2__c": string;
  "License_or_Certification_Name_1__c": string;
  "License_or_Certification_Name_2__c": string;
  "LinkedIn_Profile__c": string;
  "Login_Password__c": string;
  "Longitude__c": number;
  "MailingCountryText__c": string;
  "MailingStateText__c": string;
  "Match__c": number;
  "Memo__c": string;
  "Middlename__c": string;
  "Military_History_Type__c": string;
  "Mobile_Telephone_Number__c": string;
  "Notice__c": string;
  "Opt_In_to_Job_Alerts__c": boolean;
  "People_Status__c": string;
  "Picture_Id__c": string;
  "Picture__c": string;
  "Preferred_Name__c": string;
  "Qualification_Summary__c": string;
  "Reference_1__c": string;
  "Reference_2__c": string;
  "Referral_Lookup__c": string;
  "ReferrerEmailMessage__c": string;
  "ReferrerEmailSubject__c": string;
  "Relocated__c": boolean;
  "Relocation_Date__c": Date;
  "Resume_Last_Updated__c": Date;
  "SSN1__c": string;
  "SSN2__c": string;
  "SSN3__c": string;
  "Search_Social_Profiles__c": string;
  "Second_Best_Fit__c": string;
  "Security_Credential_1__c": string;
  "Security_Credential_Description_1__c": string;
  "Security_Credential_Type_1__c": string;
  "SessionKey__c": string;
  "Shift__c": string;
  "Skill_Codes__c": string;
  "Social_Security__c": string;
  "Soft_Rating__c": string;
  "Soft_Skills__c": number;
  "Source_Notes__c": string;
  "Source__c": string;
  "Taxonomy_Last_12_Months__c": string;
  "Taxonomy_Qualifications__c": string;
  "Taxonomy_Skills__c": string;
  "Taxonomy_Work_History_12_24__c": string;
  "Taxonomy_Work_History_24_36__c": string;
  "Taxonomy_Work_History_36_48__c": string;
  "Text_Resume__c": string;
  "Total_Months_Employed__c": number;
  "Travel_Desired__c": number;
  "Twitter_Profile__c": string;
  "Verified_Date__c": Date;
  "Verified_Key__c": string;
  "Verified__c": boolean;
  "W4_Received__c": boolean;
  "Years_of_Experience__c": number;
  "iPaper_Key__c": string;
  "Languages_js__c": string;
  "Level_js__c": string;
  "Initiate_Background_Check__c": boolean;
  "zeitzone__MailingLTFactor__c": number;
  "zeitzone__MailingLocalTime__c": string;
  "zeitzone__MailingTimeZoneId__c": string;
  "zeitzone__OtherLTFactor__c": number;
  "zeitzone__OtherLocalTime__c": string;
  "zeitzone__otherTimeZoneId__c": string;
  "Candidate_Salary_Term__c": string;
  "Count_of_Primary_Email__c": number;
  "Health_MSP_Email__c": string;
  "Health_Portal_Access__c": string;
  "MSP_Internal_Email_verified__c": boolean;
  "Portal_Access_Email__c": boolean;
  "Full_Account_Name__c": string;
  "Send_RFI_Email__c": boolean;
  "isMailingAddressChanged__c": boolean;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  account: Account;
  worker: Worker[];
  users: Users;
  jobsite: Jobsite;
  countryCode: CountryCode;
  geometro: GeoMetro;
  skillings: Skilling[];
  department: Department;
  stateManager: StateManager;
  constructor(data?: ContactInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Contact`.
   */
  public static getModelName() {
    return "Contact";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Contact for dynamic purposes.
  **/
  public static factory(data: ContactInterface): Contact{
    return new Contact(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Contact',
      plural: 'Contacts',
      path: 'Contacts',
      idName: 'id',
      properties: {
        "UserId": {
          name: 'UserId',
          type: 'number'
        },
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "AccountId": {
          name: 'AccountId',
          type: 'string'
        },
        "Active__c": {
          name: 'Active__c',
          type: 'boolean'
        },
        "Advanced_System_User__c": {
          name: 'Advanced_System_User__c',
          type: 'boolean',
          default: false
        },
        "AssistantName": {
          name: 'AssistantName',
          type: 'string'
        },
        "AssistantPhone": {
          name: 'AssistantPhone',
          type: 'string'
        },
        "Bachelors_Degree__c": {
          name: 'Bachelors_Degree__c',
          type: 'string'
        },
        "Birthdate": {
          name: 'Birthdate',
          type: 'Date'
        },
        "CKSW_BASE__Languages__c": {
          name: 'CKSW_BASE__Languages__c',
          type: 'string'
        },
        "CKSW_BASE__Level__c": {
          name: 'CKSW_BASE__Level__c',
          type: 'string'
        },
        "Candidate_Id_Ref__c": {
          name: 'Candidate_Id_Ref__c',
          type: 'string'
        },
        "Contact_Full_Name__c": {
          name: 'Contact_Full_Name__c',
          type: 'string'
        },
        "Contact_Name__c": {
          name: 'Contact_Name__c',
          type: 'string'
        },
        "Contact_Overview__c": {
          name: 'Contact_Overview__c',
          type: 'string'
        },
        "Contact_Time_Zone__c": {
          name: 'Contact_Time_Zone__c',
          type: 'string'
        },
        "Contact_Type__c": {
          name: 'Contact_Type__c',
          type: 'string'
        },
        "ContractorHourly__c": {
          name: 'ContractorHourly__c',
          type: 'string'
        },
        "Country_Code__c": {
          name: 'Country_Code__c',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "Current_Employer__c": {
          name: 'Current_Employer__c',
          type: 'string'
        },
        "Department": {
          name: 'Department',
          type: 'string'
        },
        "Description": {
          name: 'Description',
          type: 'string'
        },
        "Disable_PMS_Portal_Login__c": {
          name: 'Disable_PMS_Portal_Login__c',
          type: 'boolean'
        },
        "Education_Years__c": {
          name: 'Education_Years__c',
          type: 'number'
        },
        "Email": {
          name: 'Email',
          type: 'string'
        },
        "EmailBouncedDate": {
          name: 'EmailBouncedDate',
          type: 'Date'
        },
        "EmailBouncedReason": {
          name: 'EmailBouncedReason',
          type: 'string'
        },
        "Email__c": {
          name: 'Email__c',
          type: 'string'
        },
        "Employed__c": {
          name: 'Employed__c',
          type: 'string'
        },
        "Enable_App_Login__c": {
          name: 'Enable_App_Login__c',
          type: 'boolean',
          default: false
        },
        "Enable_Inventory_Update__c": {
          name: 'Enable_Inventory_Update__c',
          type: 'boolean',
          default: false
        },
        "ExperienceYrs__c": {
          name: 'ExperienceYrs__c',
          type: 'number'
        },
        "Fax": {
          name: 'Fax',
          type: 'string'
        },
        "FirstName": {
          name: 'FirstName',
          type: 'string'
        },
        "GEO_Code__c": {
          name: 'GEO_Code__c',
          type: 'string'
        },
        "Gender__c": {
          name: 'Gender__c',
          type: 'string'
        },
        "Graduation_Date__c": {
          name: 'Graduation_Date__c',
          type: 'Date'
        },
        "HomePhone": {
          name: 'HomePhone',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "IsEmailBounced": {
          name: 'IsEmailBounced',
          type: 'boolean'
        },
        "Jigsaw": {
          name: 'Jigsaw',
          type: 'string'
        },
        "JigsawContactId": {
          name: 'JigsawContactId',
          type: 'string'
        },
        "Job_Opportunity__c": {
          name: 'Job_Opportunity__c',
          type: 'string'
        },
        "Languages_Known__c": {
          name: 'Languages_Known__c',
          type: 'string'
        },
        "LastActivityDate": {
          name: 'LastActivityDate',
          type: 'Date'
        },
        "LastCURequestDate": {
          name: 'LastCURequestDate',
          type: 'Date'
        },
        "LastCUUpdateDate": {
          name: 'LastCUUpdateDate',
          type: 'Date'
        },
        "LastLogin__c": {
          name: 'LastLogin__c',
          type: 'Date'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "LastModifiedBy__c": {
          name: 'LastModifiedBy__c',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastName": {
          name: 'LastName',
          type: 'string'
        },
        "LastReferencedDate": {
          name: 'LastReferencedDate',
          type: 'Date'
        },
        "LastViewedDate": {
          name: 'LastViewedDate',
          type: 'Date'
        },
        "LeadId__c": {
          name: 'LeadId__c',
          type: 'string'
        },
        "LeadSource": {
          name: 'LeadSource',
          type: 'string'
        },
        "LinkedIn_Profile_Link__c": {
          name: 'LinkedIn_Profile_Link__c',
          type: 'string'
        },
        "List_of_Locations__c": {
          name: 'List_of_Locations__c',
          type: 'string'
        },
        "LocationList__c": {
          name: 'LocationList__c',
          type: 'string'
        },
        "MSP_Portal_User_Name__c": {
          name: 'MSP_Portal_User_Name__c',
          type: 'string'
        },
        "MailingAddress": {
          name: 'MailingAddress',
          type: 'string'
        },
        "MailingCity": {
          name: 'MailingCity',
          type: 'string'
        },
        "MailingCountry": {
          name: 'MailingCountry',
          type: 'string'
        },
        "MailingGeocodeAccuracy": {
          name: 'MailingGeocodeAccuracy',
          type: 'string'
        },
        "MailingLatitude": {
          name: 'MailingLatitude',
          type: 'number'
        },
        "MailingLongitude": {
          name: 'MailingLongitude',
          type: 'number'
        },
        "MailingPostalCode": {
          name: 'MailingPostalCode',
          type: 'string'
        },
        "MailingState": {
          name: 'MailingState',
          type: 'string'
        },
        "MailingStreet": {
          name: 'MailingStreet',
          type: 'string'
        },
        "MasterRecordId": {
          name: 'MasterRecordId',
          type: 'string'
        },
        "Masters_Degree__c": {
          name: 'Masters_Degree__c',
          type: 'string'
        },
        "MobilePhone": {
          name: 'MobilePhone',
          type: 'string'
        },
        "MyHomeMetro_Code__c": {
          name: 'MyHomeMetro_Code__c',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "OtherAddress": {
          name: 'OtherAddress',
          type: 'string'
        },
        "OtherCity": {
          name: 'OtherCity',
          type: 'string'
        },
        "OtherCountry": {
          name: 'OtherCountry',
          type: 'string'
        },
        "OtherGeocodeAccuracy": {
          name: 'OtherGeocodeAccuracy',
          type: 'string'
        },
        "OtherLatitude": {
          name: 'OtherLatitude',
          type: 'number'
        },
        "OtherLongitude": {
          name: 'OtherLongitude',
          type: 'number'
        },
        "OtherPhone": {
          name: 'OtherPhone',
          type: 'string'
        },
        "OtherPostalCode": {
          name: 'OtherPostalCode',
          type: 'string'
        },
        "OtherState": {
          name: 'OtherState',
          type: 'string'
        },
        "OtherStreet": {
          name: 'OtherStreet',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "PMS_User_Name__c": {
          name: 'PMS_User_Name__c',
          type: 'string'
        },
        "Partner_Account__c": {
          name: 'Partner_Account__c',
          type: 'string'
        },
        "Password__c": {
          name: 'Password__c',
          type: 'string'
        },
        "Phone": {
          name: 'Phone',
          type: 'string'
        },
        "PhotoUrl": {
          name: 'PhotoUrl',
          type: 'string'
        },
        "Post_Graduation_Date__c": {
          name: 'Post_Graduation_Date__c',
          type: 'Date'
        },
        "Reason_For_switching__c": {
          name: 'Reason_For_switching__c',
          type: 'string'
        },
        "RecordTypeId": {
          name: 'RecordTypeId',
          type: 'string'
        },
        "Record_Id__c": {
          name: 'Record_Id__c',
          type: 'string'
        },
        "ReportsToId": {
          name: 'ReportsToId',
          type: 'string'
        },
        "Resource_Id__c": {
          name: 'Resource_Id__c',
          type: 'string'
        },
        "Resume__c": {
          name: 'Resume__c',
          type: 'string'
        },
        "Role__c": {
          name: 'Role__c',
          type: 'string'
        },
        "Salutation": {
          name: 'Salutation',
          type: 'string'
        },
        "Skilling__c": {
          name: 'Skilling__c',
          type: 'string'
        },
        "Standard_System_User__c": {
          name: 'Standard_System_User__c',
          type: 'boolean',
          default: false
        },
        "State__c": {
          name: 'State__c',
          type: 'string'
        },
        "Strengths_Weaknesses__c": {
          name: 'Strengths_Weaknesses__c',
          type: 'string'
        },
        "Title": {
          name: 'Title',
          type: 'string'
        },
        "Total_Experience_Months__c": {
          name: 'Total_Experience_Months__c',
          type: 'number'
        },
        "Total_Work_Exp__c": {
          name: 'Total_Work_Exp__c',
          type: 'number'
        },
        "User_Id__c": {
          name: 'User_Id__c',
          type: 'string'
        },
        "User_Type__c": {
          name: 'User_Type__c',
          type: 'string'
        },
        "Username__c": {
          name: 'Username__c',
          type: 'string'
        },
        "WM_Contact_Id__c": {
          name: 'WM_Contact_Id__c',
          type: 'string'
        },
        "WM_User_ID__c": {
          name: 'WM_User_ID__c',
          type: 'string'
        },
        "sendLoginInfo__c": {
          name: 'sendLoginInfo__c',
          type: 'boolean',
          default: false
        },
        "Action__c": {
          name: 'Action__c',
          type: 'string'
        },
        "Active_Search__c": {
          name: 'Active_Search__c',
          type: 'boolean',
          default: false
        },
        "Asst_Email__c": {
          name: 'Asst_Email__c',
          type: 'string'
        },
        "Best_Fit__c": {
          name: 'Best_Fit__c',
          type: 'string'
        },
        "Business_Telephone_Number__c": {
          name: 'Business_Telephone_Number__c',
          type: 'string'
        },
        "Business_Unit__c": {
          name: 'Business_Unit__c',
          type: 'string'
        },
        "Candidate_Source__c": {
          name: 'Candidate_Source__c',
          type: 'string'
        },
        "Certifications__c": {
          name: 'Certifications__c',
          type: 'string'
        },
        "Contact_Method__c": {
          name: 'Contact_Method__c',
          type: 'string'
        },
        "Contact_Tags__c": {
          name: 'Contact_Tags__c',
          type: 'string'
        },
        "Credentials_Private_Key__c": {
          name: 'Credentials_Private_Key__c',
          type: 'string'
        },
        "Current_Hourly__c": {
          name: 'Current_Hourly__c',
          type: 'number'
        },
        "Current_Salary__c": {
          name: 'Current_Salary__c',
          type: 'number'
        },
        "Date_Available__c": {
          name: 'Date_Available__c',
          type: 'Date'
        },
        "Desired_Hourly__c": {
          name: 'Desired_Hourly__c',
          type: 'number'
        },
        "Desired_Salary__c": {
          name: 'Desired_Salary__c',
          type: 'number'
        },
        "DischargeStatus__c": {
          name: 'DischargeStatus__c',
          type: 'string'
        },
        "Doc_Id__c": {
          name: 'Doc_Id__c',
          type: 'string'
        },
        "EEO_Disabled_Received__c": {
          name: 'EEO_Disabled_Received__c',
          type: 'string'
        },
        "EEO_Disabled__c": {
          name: 'EEO_Disabled__c',
          type: 'string'
        },
        "EEO_Gender_Received__c": {
          name: 'EEO_Gender_Received__c',
          type: 'string'
        },
        "EEO_Gender__c": {
          name: 'EEO_Gender__c',
          type: 'string'
        },
        "EEO_Populate__c": {
          name: 'EEO_Populate__c',
          type: 'boolean'
        },
        "EEO_Race_Received__c": {
          name: 'EEO_Race_Received__c',
          type: 'string'
        },
        "EEO_Race__c": {
          name: 'EEO_Race__c',
          type: 'string'
        },
        "EEO_Veteran_Status_Received__c": {
          name: 'EEO_Veteran_Status_Received__c',
          type: 'string'
        },
        "EEO_Veteran_Status__c": {
          name: 'EEO_Veteran_Status__c',
          type: 'string'
        },
        "EduDegreeDate1__c": {
          name: 'EduDegreeDate1__c',
          type: 'Date'
        },
        "EduDegreeDate2__c": {
          name: 'EduDegreeDate2__c',
          type: 'Date'
        },
        "EduDegreeMajor1__c": {
          name: 'EduDegreeMajor1__c',
          type: 'string'
        },
        "EduDegreeMajor2__c": {
          name: 'EduDegreeMajor2__c',
          type: 'string'
        },
        "EduDegreeMinor1__c": {
          name: 'EduDegreeMinor1__c',
          type: 'string'
        },
        "EduDegreeMinor2__c": {
          name: 'EduDegreeMinor2__c',
          type: 'string'
        },
        "EduDegreeName1__c": {
          name: 'EduDegreeName1__c',
          type: 'string'
        },
        "EduDegreeName2__c": {
          name: 'EduDegreeName2__c',
          type: 'string'
        },
        "EduDegreeType1__c": {
          name: 'EduDegreeType1__c',
          type: 'string'
        },
        "EduDegreeType2__c": {
          name: 'EduDegreeType2__c',
          type: 'string'
        },
        "EduOtherHonors1__c": {
          name: 'EduOtherHonors1__c',
          type: 'string'
        },
        "EduOtherHonors2__c": {
          name: 'EduOtherHonors2__c',
          type: 'string'
        },
        "EduacademicHonors1__c": {
          name: 'EduacademicHonors1__c',
          type: 'string'
        },
        "EduacademicHonors2__c": {
          name: 'EduacademicHonors2__c',
          type: 'string'
        },
        "Education_School_1__c": {
          name: 'Education_School_1__c',
          type: 'string'
        },
        "Education_School_2__c": {
          name: 'Education_School_2__c',
          type: 'string'
        },
        "Education__c": {
          name: 'Education__c',
          type: 'string'
        },
        "Edudocumentation1__c": {
          name: 'Edudocumentation1__c',
          type: 'string'
        },
        "Edudocumentation2__c": {
          name: 'Edudocumentation2__c',
          type: 'string'
        },
        "EduhonorsProgram1__c": {
          name: 'EduhonorsProgram1__c',
          type: 'string'
        },
        "EduhonorsProgram2__c": {
          name: 'EduhonorsProgram2__c',
          type: 'string'
        },
        "EduschoolTypes1__c": {
          name: 'EduschoolTypes1__c',
          type: 'string'
        },
        "EduschoolTypes2__c": {
          name: 'EduschoolTypes2__c',
          type: 'string'
        },
        "Emp_PositionHistory_positiontype1__c": {
          name: 'Emp_PositionHistory_positiontype1__c',
          type: 'string'
        },
        "Emp_PositionHistory_positiontype2__c": {
          name: 'Emp_PositionHistory_positiontype2__c',
          type: 'string'
        },
        "Employer1CategoryCode__c": {
          name: 'Employer1CategoryCode__c',
          type: 'string'
        },
        "Employer1Description__c": {
          name: 'Employer1Description__c',
          type: 'string'
        },
        "Employer1EndDate__c": {
          name: 'Employer1EndDate__c',
          type: 'Date'
        },
        "Employer1StartDate__c": {
          name: 'Employer1StartDate__c',
          type: 'Date'
        },
        "Employer1Title__c": {
          name: 'Employer1Title__c',
          type: 'string'
        },
        "Employer2Description__c": {
          name: 'Employer2Description__c',
          type: 'string'
        },
        "Employer2EndDate__c": {
          name: 'Employer2EndDate__c',
          type: 'Date'
        },
        "Employer2StartDate__c": {
          name: 'Employer2StartDate__c',
          type: 'Date'
        },
        "Employer2Title__c": {
          name: 'Employer2Title__c',
          type: 'string'
        },
        "Employer2_Category_Code__c": {
          name: 'Employer2_Category_Code__c',
          type: 'string'
        },
        "Employer3Description__c": {
          name: 'Employer3Description__c',
          type: 'string'
        },
        "Employer3EndDate__c": {
          name: 'Employer3EndDate__c',
          type: 'Date'
        },
        "Employer3StartDate__c": {
          name: 'Employer3StartDate__c',
          type: 'Date'
        },
        "Employer3Title__c": {
          name: 'Employer3Title__c',
          type: 'string'
        },
        "Employer3_Category_Code__c": {
          name: 'Employer3_Category_Code__c',
          type: 'string'
        },
        "EmployerOrgName_1__c": {
          name: 'EmployerOrgName_1__c',
          type: 'string'
        },
        "EmployerOrgName_2__c": {
          name: 'EmployerOrgName_2__c',
          type: 'string'
        },
        "EmployerOrgName_3__c": {
          name: 'EmployerOrgName_3__c',
          type: 'string'
        },
        "Executive_summary__c": {
          name: 'Executive_summary__c',
          type: 'string'
        },
        "Experience_Summary__c": {
          name: 'Experience_Summary__c',
          type: 'string'
        },
        "Facebook_Profile__c": {
          name: 'Facebook_Profile__c',
          type: 'string'
        },
        "Firstname__c": {
          name: 'Firstname__c',
          type: 'string'
        },
        "Geo_Location_Passed__c": {
          name: 'Geo_Location_Passed__c',
          type: 'boolean'
        },
        "Hard_Rating__c": {
          name: 'Hard_Rating__c',
          type: 'string'
        },
        "Hard_Skills__c": {
          name: 'Hard_Skills__c',
          type: 'string'
        },
        "HasEmailBounced__c": {
          name: 'HasEmailBounced__c',
          type: 'boolean'
        },
        "Hide_Photo__c": {
          name: 'Hide_Photo__c',
          type: 'boolean'
        },
        "Home_Telephone_Number__c": {
          name: 'Home_Telephone_Number__c',
          type: 'string'
        },
        "I9_Received__c": {
          name: 'I9_Received__c',
          type: 'boolean'
        },
        "Internet_Email_Address__c": {
          name: 'Internet_Email_Address__c',
          type: 'string'
        },
        "Job_Type__c": {
          name: 'Job_Type__c',
          type: 'string'
        },
        "Jobs_Applied_For__c": {
          name: 'Jobs_Applied_For__c',
          type: 'string'
        },
        "LUID__c": {
          name: 'LUID__c',
          type: 'string'
        },
        "Language_Comments_1__c": {
          name: 'Language_Comments_1__c',
          type: 'string'
        },
        "Language_Comments_2__c": {
          name: 'Language_Comments_2__c',
          type: 'string'
        },
        "Language_Read_1__c": {
          name: 'Language_Read_1__c',
          type: 'string'
        },
        "Language_Read_2__c": {
          name: 'Language_Read_2__c',
          type: 'string'
        },
        "Language_Speak_1__c": {
          name: 'Language_Speak_1__c',
          type: 'string'
        },
        "Language_Speak_2__c": {
          name: 'Language_Speak_2__c',
          type: 'string'
        },
        "Language_Write_1__c": {
          name: 'Language_Write_1__c',
          type: 'string'
        },
        "Language_Write_2__c": {
          name: 'Language_Write_2__c',
          type: 'string'
        },
        "Languages__c": {
          name: 'Languages__c',
          type: 'string'
        },
        "Lastname__c": {
          name: 'Lastname__c',
          type: 'string'
        },
        "Latitude__c": {
          name: 'Latitude__c',
          type: 'number'
        },
        "Legacy_ContactID__c": {
          name: 'Legacy_ContactID__c',
          type: 'string'
        },
        "Legacy_DocumentID__c": {
          name: 'Legacy_DocumentID__c',
          type: 'string'
        },
        "Level__c": {
          name: 'Level__c',
          type: 'string'
        },
        "License_or_Certification_Credential_Type__c": {
          name: 'License_or_Certification_Credential_Type__c',
          type: 'string'
        },
        "License_or_Certification_Description_1__c": {
          name: 'License_or_Certification_Description_1__c',
          type: 'string'
        },
        "License_or_Certification_Description_2__c": {
          name: 'License_or_Certification_Description_2__c',
          type: 'string'
        },
        "License_or_Certification_Name_1__c": {
          name: 'License_or_Certification_Name_1__c',
          type: 'string'
        },
        "License_or_Certification_Name_2__c": {
          name: 'License_or_Certification_Name_2__c',
          type: 'string'
        },
        "LinkedIn_Profile__c": {
          name: 'LinkedIn_Profile__c',
          type: 'string'
        },
        "Login_Password__c": {
          name: 'Login_Password__c',
          type: 'string'
        },
        "Longitude__c": {
          name: 'Longitude__c',
          type: 'number'
        },
        "MailingCountryText__c": {
          name: 'MailingCountryText__c',
          type: 'string'
        },
        "MailingStateText__c": {
          name: 'MailingStateText__c',
          type: 'string'
        },
        "Match__c": {
          name: 'Match__c',
          type: 'number'
        },
        "Memo__c": {
          name: 'Memo__c',
          type: 'string'
        },
        "Middlename__c": {
          name: 'Middlename__c',
          type: 'string'
        },
        "Military_History_Type__c": {
          name: 'Military_History_Type__c',
          type: 'string'
        },
        "Mobile_Telephone_Number__c": {
          name: 'Mobile_Telephone_Number__c',
          type: 'string'
        },
        "Notice__c": {
          name: 'Notice__c',
          type: 'string'
        },
        "Opt_In_to_Job_Alerts__c": {
          name: 'Opt_In_to_Job_Alerts__c',
          type: 'boolean'
        },
        "People_Status__c": {
          name: 'People_Status__c',
          type: 'string'
        },
        "Picture_Id__c": {
          name: 'Picture_Id__c',
          type: 'string'
        },
        "Picture__c": {
          name: 'Picture__c',
          type: 'string'
        },
        "Preferred_Name__c": {
          name: 'Preferred_Name__c',
          type: 'string'
        },
        "Qualification_Summary__c": {
          name: 'Qualification_Summary__c',
          type: 'string'
        },
        "Reference_1__c": {
          name: 'Reference_1__c',
          type: 'string'
        },
        "Reference_2__c": {
          name: 'Reference_2__c',
          type: 'string'
        },
        "Referral_Lookup__c": {
          name: 'Referral_Lookup__c',
          type: 'string'
        },
        "ReferrerEmailMessage__c": {
          name: 'ReferrerEmailMessage__c',
          type: 'string'
        },
        "ReferrerEmailSubject__c": {
          name: 'ReferrerEmailSubject__c',
          type: 'string'
        },
        "Relocated__c": {
          name: 'Relocated__c',
          type: 'boolean'
        },
        "Relocation_Date__c": {
          name: 'Relocation_Date__c',
          type: 'Date'
        },
        "Resume_Last_Updated__c": {
          name: 'Resume_Last_Updated__c',
          type: 'Date'
        },
        "SSN1__c": {
          name: 'SSN1__c',
          type: 'string'
        },
        "SSN2__c": {
          name: 'SSN2__c',
          type: 'string'
        },
        "SSN3__c": {
          name: 'SSN3__c',
          type: 'string'
        },
        "Search_Social_Profiles__c": {
          name: 'Search_Social_Profiles__c',
          type: 'string'
        },
        "Second_Best_Fit__c": {
          name: 'Second_Best_Fit__c',
          type: 'string'
        },
        "Security_Credential_1__c": {
          name: 'Security_Credential_1__c',
          type: 'string'
        },
        "Security_Credential_Description_1__c": {
          name: 'Security_Credential_Description_1__c',
          type: 'string'
        },
        "Security_Credential_Type_1__c": {
          name: 'Security_Credential_Type_1__c',
          type: 'string'
        },
        "SessionKey__c": {
          name: 'SessionKey__c',
          type: 'string'
        },
        "Shift__c": {
          name: 'Shift__c',
          type: 'string'
        },
        "Skill_Codes__c": {
          name: 'Skill_Codes__c',
          type: 'string'
        },
        "Social_Security__c": {
          name: 'Social_Security__c',
          type: 'string'
        },
        "Soft_Rating__c": {
          name: 'Soft_Rating__c',
          type: 'string'
        },
        "Soft_Skills__c": {
          name: 'Soft_Skills__c',
          type: 'number'
        },
        "Source_Notes__c": {
          name: 'Source_Notes__c',
          type: 'string'
        },
        "Source__c": {
          name: 'Source__c',
          type: 'string'
        },
        "Taxonomy_Last_12_Months__c": {
          name: 'Taxonomy_Last_12_Months__c',
          type: 'string'
        },
        "Taxonomy_Qualifications__c": {
          name: 'Taxonomy_Qualifications__c',
          type: 'string'
        },
        "Taxonomy_Skills__c": {
          name: 'Taxonomy_Skills__c',
          type: 'string'
        },
        "Taxonomy_Work_History_12_24__c": {
          name: 'Taxonomy_Work_History_12_24__c',
          type: 'string'
        },
        "Taxonomy_Work_History_24_36__c": {
          name: 'Taxonomy_Work_History_24_36__c',
          type: 'string'
        },
        "Taxonomy_Work_History_36_48__c": {
          name: 'Taxonomy_Work_History_36_48__c',
          type: 'string'
        },
        "Text_Resume__c": {
          name: 'Text_Resume__c',
          type: 'string'
        },
        "Total_Months_Employed__c": {
          name: 'Total_Months_Employed__c',
          type: 'number'
        },
        "Travel_Desired__c": {
          name: 'Travel_Desired__c',
          type: 'number'
        },
        "Twitter_Profile__c": {
          name: 'Twitter_Profile__c',
          type: 'string'
        },
        "Verified_Date__c": {
          name: 'Verified_Date__c',
          type: 'Date'
        },
        "Verified_Key__c": {
          name: 'Verified_Key__c',
          type: 'string'
        },
        "Verified__c": {
          name: 'Verified__c',
          type: 'boolean'
        },
        "W4_Received__c": {
          name: 'W4_Received__c',
          type: 'boolean'
        },
        "Years_of_Experience__c": {
          name: 'Years_of_Experience__c',
          type: 'number'
        },
        "iPaper_Key__c": {
          name: 'iPaper_Key__c',
          type: 'string'
        },
        "Languages_js__c": {
          name: 'Languages_js__c',
          type: 'string'
        },
        "Level_js__c": {
          name: 'Level_js__c',
          type: 'string'
        },
        "Initiate_Background_Check__c": {
          name: 'Initiate_Background_Check__c',
          type: 'boolean'
        },
        "zeitzone__MailingLTFactor__c": {
          name: 'zeitzone__MailingLTFactor__c',
          type: 'number'
        },
        "zeitzone__MailingLocalTime__c": {
          name: 'zeitzone__MailingLocalTime__c',
          type: 'string'
        },
        "zeitzone__MailingTimeZoneId__c": {
          name: 'zeitzone__MailingTimeZoneId__c',
          type: 'string'
        },
        "zeitzone__OtherLTFactor__c": {
          name: 'zeitzone__OtherLTFactor__c',
          type: 'number'
        },
        "zeitzone__OtherLocalTime__c": {
          name: 'zeitzone__OtherLocalTime__c',
          type: 'string'
        },
        "zeitzone__otherTimeZoneId__c": {
          name: 'zeitzone__otherTimeZoneId__c',
          type: 'string'
        },
        "Candidate_Salary_Term__c": {
          name: 'Candidate_Salary_Term__c',
          type: 'string'
        },
        "Count_of_Primary_Email__c": {
          name: 'Count_of_Primary_Email__c',
          type: 'number'
        },
        "Health_MSP_Email__c": {
          name: 'Health_MSP_Email__c',
          type: 'string'
        },
        "Health_Portal_Access__c": {
          name: 'Health_Portal_Access__c',
          type: 'string'
        },
        "MSP_Internal_Email_verified__c": {
          name: 'MSP_Internal_Email_verified__c',
          type: 'boolean'
        },
        "Portal_Access_Email__c": {
          name: 'Portal_Access_Email__c',
          type: 'boolean'
        },
        "Full_Account_Name__c": {
          name: 'Full_Account_Name__c',
          type: 'string'
        },
        "Send_RFI_Email__c": {
          name: 'Send_RFI_Email__c',
          type: 'boolean'
        },
        "isMailingAddressChanged__c": {
          name: 'isMailingAddressChanged__c',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        account: {
          name: 'account',
          type: 'Account',
          model: 'Account',
          relationType: 'belongsTo',
                  keyFrom: 'AccountId',
          keyTo: 'sfdcId'
        },
        worker: {
          name: 'worker',
          type: 'Worker[]',
          model: 'Worker',
          relationType: 'hasMany',
                  keyFrom: 'sfdcId',
          keyTo: 'Contact__c'
        },
        users: {
          name: 'users',
          type: 'Users',
          model: 'Users',
          relationType: 'belongsTo',
                  keyFrom: 'UserId',
          keyTo: 'id'
        },
        jobsite: {
          name: 'jobsite',
          type: 'Jobsite',
          model: 'Jobsite',
          relationType: 'belongsTo',
                  keyFrom: 'sfdcId',
          keyTo: 'Jobsite_Key_Contact__c'
        },
        countryCode: {
          name: 'countryCode',
          type: 'CountryCode',
          model: 'CountryCode',
          relationType: 'belongsTo',
                  keyFrom: 'Country_Code__c',
          keyTo: 'sfdcId'
        },
        geometro: {
          name: 'geometro',
          type: 'GeoMetro',
          model: 'GeoMetro',
          relationType: 'belongsTo',
                  keyFrom: 'MyHomeMetro_Code__c',
          keyTo: 'sfdcId'
        },
        skillings: {
          name: 'skillings',
          type: 'Skilling[]',
          model: 'Skilling',
          relationType: 'hasMany',
                  keyFrom: 'sfdcId',
          keyTo: 'Resource__c'
        },
        department: {
          name: 'department',
          type: 'Department',
          model: 'Department',
          relationType: 'belongsTo',
                  keyFrom: 'Department',
          keyTo: 'sfdcId'
        },
        stateManager: {
          name: 'stateManager',
          type: 'StateManager',
          model: 'StateManager',
          relationType: 'belongsTo',
                  keyFrom: 'State__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
